<template>
  <PhraseLibrary
    v-slot="{ onInput, onKeydown }"
    :chat-textarea-ref="$refs.textarea"
    scroll-container-selector=".main-wrapper__side-right"
    @phrase-selected="handlePhraseSelected"
  >
    <textarea
      ref="textarea"
      :value="modelValue"
      :style="styles"
      :rows="rows"
      :cols="cols"
      :placeholder="placeholder"
      :data-test="dataTest"
      wrap="hard"
      @input="
        (e) => {
          $emit('update:modelValue', e.target.value);
          if (onInput) onInput(e);
        }
      "
      @focus="resize"
      @keydown="onKeydown"
    />
  </PhraseLibrary>
</template>

<script>
import { nextTick, ref } from "vue";
import PhraseLibrary from "../Admin/Users/User/UserPhraseLibrary/PhraseLibrary.vue";
import { insertPhraseIntoTextarea } from "../Utils/phraselibrary";

/**
 * @see https://github.com/DneshP/resize-textarea-vue3
 */
export default {
  name: "ResizeTextarea",
  components: { PhraseLibrary },
  props: {
    /**
     * Placeholder text
     */
    placeholder: {
      type: String,
      default: "",
    },
    /**
     * Number of rows
     */
    rows: {
      type: Number,
      default: 2,
    },
    /**
     * Number of columns
     */
    cols: {
      type: Number,
      default: 0,
    },
    /**
     * Minimum height of the textarea
     */
    minHeight: {
      type: Number,
      default: 50,
    },
    /**
     * Maximum height of the textarea
     */
    maxHeight: {
      type: Number,
      default: null,
    },
    /**
     * The textarea value
     */
    modelValue: {
      type: [String, Number],
      default: "",
    },
    /**
     * The resize handle is disabled by default
     */
    autoResize: {
      type: Boolean,
      default: true,
    },
    /** Optional `data-test` attribute forwarded to the underlying textarea. */
    dataTest: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      height: "",
      isScrollEnabled: false,
    };
  },
  computed: {
    styles() {
      return {
        resize: this.autoResize ? "none !important" : "",
        padding: `5${this.unit}`,
        height: this.height,
        overflow: `${this.isScrollEnabled ? "scroll" : "hidden"} !important`,
      };
    },
    unit() {
      return "px";
    },
  },
  watch: {
    modelValue() {
      this.resize();
    },
  },
  mounted() {
    this.resize();
  },
  methods: {
    handlePhraseSelected(phrase) {
      const textarea = this.$refs.textarea;
      const text = ref(this.modelValue?.toString() ?? "");

      if (textarea) {
        insertPhraseIntoTextarea(textarea, text, phrase).then(() => {
          this.$emit("update:modelValue", text.value); // sync back
        });
      }
    },
    resize() {
      const element = this.$refs.textarea;
      this.height = "auto !important";
      nextTick(() => {
        if (this.minHeight) {
          this.height = `${
            element.scrollHeight < this.minHeight
              ? this.minHeight
              : element.scrollHeight
          }${this.unit}`;
        }
        if (this.maxHeight) {
          if (element.scrollHeight > this.maxHeight) {
            this.height = `${this.maxHeight}${this.unit}`;
            this.isScrollEnabled = true;
          } else {
            this.isScrollEnabled = false;
          }
        }
      });
    },
  },
};
</script>
